import React from 'react';
import { SubTitle, Description, Image } from '../../components/layouts';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';

const IMAGE = buildImageURL('/game-1.png');
const IMAGE_Webp = buildImageURL('/game-1.webp');
const IMAGE_M = buildImageURL('/game-m-1.png');
const IMAGE_M_Webp = buildImageURL('/game-m-1.webp');
const isWebp = document.querySelector('html').classList.contains('webpSupport');
const IMG_Pc = isWebp ? IMAGE_Webp : IMAGE;
const IMG_Wap = isWebp ? IMAGE_M_Webp : IMAGE_M;


const track = getTrack({ block: 22 });

export function  GamePlay({mobile = false}) {
  return (
    <div className="page-section section-game-play inverted" data-track={track}>
      <div className="txt-wrapper">
        {!mobile && <SubTitle>
          游戏电竞，够爽才能 battle
        </SubTitle>}
        {mobile && <SubTitle>
          游戏电竞
          <br/>
          够爽才能 battle
        </SubTitle>}
        <Description>
          游戏画面高清流畅，鹰眼模式 2.0 与游戏护眼 2.0，保障优质的游戏体
          <br/>
          验的同时，即便长时间游戏，仍有效缓解眼睛的疲劳程度。
        </Description>
      </div>
      <Image className="img-wrapper" src={mobile ? IMG_Wap : IMG_Pc} />
    </div>

  

  );
}
